module.exports = __webpack_public_path__ + "img/shexiang1.13d4b673.png";